import { c as _c } from "react/compiler-runtime";
import { VscGithubInverted } from 'react-icons/vsc';
import { FaLinkedin } from 'react-icons/fa';
import { cn } from '@/lib/utils';
type SocialLinksProps = {
  className?: string;
  linkClassName?: string;
  iconSize?: number;
};
export default function SocialLinks(t0) {
  const $ = _c(20);
  const {
    className,
    linkClassName,
    iconSize: t1
  } = t0;
  const iconSize = t1 === undefined ? 22 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-wrap items-center gap-4 text-[0.95rem]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== linkClassName) {
    t3 = cn("text-content-text inline-flex items-center gap-2 opacity-80 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-black/10 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-hidden dark:focus-visible:ring-white/25 dark:focus-visible:ring-offset-zinc-950", linkClassName);
    $[2] = linkClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconSize) {
    t4 = <VscGithubInverted color="currentColor" size={iconSize} />;
    $[4] = iconSize;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <a className={t3} href="https://github.com/trolund" rel="noreferrer" target="_blank">{t4}GitHub</a>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== linkClassName) {
    t6 = cn("text-content-text inline-flex items-center gap-2 opacity-80 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-black/10 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-hidden dark:focus-visible:ring-white/25 dark:focus-visible:ring-offset-zinc-950", linkClassName);
    $[9] = linkClassName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== iconSize) {
    t7 = <FaLinkedin color="currentColor" size={iconSize} />;
    $[11] = iconSize;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <a className={t6} href="https://www.linkedin.com/in/trolund/" rel="noreferrer" target="_blank">{t7}LinkedIn</a>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div className={t2}>{t5}{t8}</div>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}